export default "__VITE_ASSET__ef2a57b7__"